import { Form, Input } from "antd";
import { requiredField } from "../common/common";
import SimpleFormPage from "../common/SimpleFormPage";
import { useLoaderData } from "react-router";

export default function () {
  const data = useLoaderData();
  const loadFn = (form) => form.setFieldsValue(data);

  return (
    <SimpleFormPage
      title="Modifica cantiere"
      loadFn={loadFn}
      layout="vertical"
      autoComplete="off"
    >
      <Form.Item label="Descrizione" rules={[requiredField]} name="description">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
